import _Object$keys from 'babel-runtime/core-js/object/keys';

import { userListAPI } from '@/api/common';
import { objDeepCopy } from '@/utils';
import PinyinMatch from 'pinyin-match';

export default {
  name: 'XhUser', // 新建 user
  components: {},
  props: {
    show: {
      type: Boolean,
      default: true
    },
    radio: {
      type: Boolean,
      default: false
    },
    // 已选信息
    selectedData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 请求加强
    infoType: {
      type: String,
      default: 'default' // 返回全部  crm_contract crm_receivables oa_examine 合同审核人自选列表
    },
    // 自定义请求
    infoRequest: Function,
    infoParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      list: [],
      selectIds: [], // 选择项
      loading: false, // 加载动画
      searchInput: '',
      checkAll: false,
      isIndeterminate: false
    };
  },

  computed: {
    showList: function showList() {
      var _this = this;

      return this.list.filter(function (item) {
        return PinyinMatch.match(item.realname || '', _this.searchInput);
      });
    },
    max: function max() {
      return this.radio ? 1 : undefined;
    }
  },
  watch: {
    selectedData: function selectedData(value) {
      if (this.show) {
        this.checkItems(value);
      }
    },

    show: function show(value) {
      if (value) {
        if (this.list && this.list.length == 0) {
          this.getUserList();
        } else {
          this.checkItems(this.selectedData);
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.show) {
      this.getUserList();
    }
  },

  methods: {
    /**
     * 获取数据
     */
    getUserList: function getUserList() {
      var _this2 = this;

      this.loading = true;
      this.getRequest()(this.getParams()).then(function (res) {
        _this2.list = res.data.list || res.data;
        _this2.checkItems(_this2.selectedData);
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },


    /**
     * 请求
     */
    getRequest: function getRequest() {
      if (this.infoRequest) {
        return this.infoRequest;
      } else if (this.infoType === 'default') {
        return userListAPI;
      } else if (this.infoType === 'crm_contract' || this.infoType === 'crm_invoice' || this.infoType === 'crm_receivables' || this.infoType === 'oa_examine') {
        return userListAPI;
      }
    },
    getParams: function getParams() {
      var params = this.infoParams && _Object$keys(this.infoParams.length !== 0) ? this.infoParams : {};
      if (this.infoType === 'default') {
        params.status = 'all';
        return params;
      } else if (this.infoType === 'crm_contract' || this.infoType === 'crm_invoice' || this.infoType === 'crm_receivables' || this.infoType === 'oa_examine') {
        params.pageType = 0;
        return params;
      }
    },


    /**
     * 勾选
     */
    changeCheckout: function changeCheckout(val) {
      this.refreshAllCheck(val.length);
      var selectItems = [];
      for (var index = 0; index < this.list.length; index++) {
        var item = this.list[index];
        if (val.includes(item.id)) {
          selectItems.push(item);
        }
      }
      this.$emit('changeCheckout', selectItems, val);
    },


    /**
     * 全部勾选
     */
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.selectIds = val ? this.list.map(function (item) {
        return item.userId;
      }) : [];
      this.isIndeterminate = false;
      var selectItems = val ? this.list : [];
      this.$emit('changeCheckout', objDeepCopy(selectItems), this.selectIds);
    },


    /**
     * 刷新总check
     */
    refreshAllCheck: function refreshAllCheck(checkedCount) {
      this.checkAll = checkedCount === this.list.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.list.length;
    },


    /**
     * 标记勾选
     */
    checkItems: function checkItems(items) {
      this.selectIds = items.map(function (item) {
        return item.id;
      });
      this.refreshAllCheck(this.selectIds.length);
    },


    /**
     * 清空全部
     */
    clearAll: function clearAll() {
      this.selectItems = [];
      this.$emit('changeCheckout', [], []);
    }
  }
};